export default __webpack_public_path__ + "static/media/illustration-4.29022f62.webp";